
import Article_Boutique from "./Article_Boutique.class";
import moment from "moment";


/**
 * @classdesc Liste des articles d'un module
 * @kind class
 * @export
 * @prop {int} id_module - Id du module
 * @prop {array} list - Liste des articles
 * @class List_Articles_Boutique
 */
export default class List_Articles_Boutique {
    id_module;
    list = [];
    infos_livraison;

    /**
     *  Initialise la liste des articles
     *
     * @constructs
     * @param id - Id du module
     * @memberof List_Articles_Boutique
     */
    constructor(id) {
        this.id_module = id;
        this.infos_livraison = {
            mode: "retrait",
            adresse_point_relai: "",
            price: 0,
            base_price: 0,
        }
    }

    initialize_from_mainstore(articles) {
        for (let i = 0; i < articles.length; i++) {
            let article = new Article_Boutique();
            article.set(articles[i]);
            if (this.list.find(o => o.id == article.id) == undefined) {
                this.list.push(article);
            }
        }
    }


    set_base_livraison_price(p) {
        this.infos_livraison.base_price = p ? parseFloat(p) : 0;
    }

    toggle_from_dossard_bourse(dossard_bourse) {

        let options_in_dossard_bourse = dossard_bourse.options.filter(option => option.type == 'article');
        for (let i = 0; i < options_in_dossard_bourse.length; i++) {
            let option = options_in_dossard_bourse[i];
            for (let j = 0; j < this.list.length; j++) {
                if (this.list[j].id == option.id_item) {

                    this.list[j].size = option.size;
                    this.list[j].quantite_souhaite = option.quantite;
                    for (let k = 0; k < this.list[j].sizes.length; k++) {
                        if (this.list[j].sizes[k].nom == option.size) {
                            this.list[j].sizes[k].quantite_souhaite = option.quantite;
                            break;
                        }
                    }
                    break;
                }
            }
        }
    }

    filter_availables_articles() {
        for (let i = this.list.length - 1; i >= 0; i--) {
            let article = this.list[i];
            const today = moment().format('YYYY-MM-DD');
            const date_max = moment(article.date_max).format('YYYY-MM-DD');
            if (today > date_max) {
                this.list.splice(i, 1);
            }
        }
    }
    /**
     * Créer la liste des articles du module
     *
     * @param {array} data
     * @memberof List_Articles_Boutique
     */
    set(data) {
        for (let i = 0; i < data.length; i++) {
            let article = new Article_Boutique();
            article.set(data[i]);
            article.set_desired_quantity_per_size();
            this.list.push(article);
        }
    }

    excess_weight_price() {
        let quantity_softshell = 0;
        this.list.forEach(article => {
            if (article.id == 7) {
                quantity_softshell += parseInt(article.quantite_souhaite);
            }
        });
        if (quantity_softshell >= 2) {
            return 1;
        }
        return 0;
    }

    update_livraison_price() {
        let price = 0;
        if (this.infos_livraison.mode == "retrait") {
            price = 0;
        }
        else if (this.infos_livraison.mode == "point_relai") {
            price = this.infos_livraison.base_price;
            price += this.excess_weight_price();
            if (this.id_module == 219) {
                price = this.calculate_price_point_relai_BOUTIQUE_VVX25();
            }
            else {
                price = this.infos_livraison.base_price;
                price += this.excess_weight_price();
            }

        }

        this.infos_livraison.price = price;
    }

    calculate_price_point_relai_BOUTIQUE_VVX25() {
        let price = 4.50;
        let weight_commande = this.calculate_weight_commande();
        if (weight_commande >= 1000) {
            price = 6.95;
        }
        return price;
    }

    calculate_weight_commande() {
        let weight_commande = 0;
        for (let i = 0; i < this.list.length; i++) {
            let article = this.list[i];
            let weight = article.get_metadata('poids_article');
            if (!weight) { continue; }
            let quantite = article.quantite_souhaite;
            if (quantite == 0) {
                continue;
            }
            weight_commande += parseInt(weight) * parseInt(quantite);

        }
        return weight_commande;
    }


    update_cart(lien_groupe = null) {
        let cart = { nb_articles: 0, prix: 0 };
        for (let i = 0; i < this.list.length; i++) {
            let item_cart = this.list[i].update_cart(lien_groupe);
            cart.nb_articles += parseInt(item_cart.nb_articles);
            cart.prix += parseFloat(item_cart.prix);
        }
        this.update_livraison_price();
        if (this.infos_livraison.price > 0) {
            cart.prix += this.infos_livraison.price;
        }

        this.cart = cart;
        return cart;
    }

    getSimplifiedData() {
        if (this.cart?.nb_articles == 0) return null;
        let infos = {};
        infos.prix = this?.cart?.prix;
        infos.list = [];
        for (let i = 0; i < this.list.length; i++) {
            const article = this.list[i];
            let article_infos = article.getSimplifiedData();
            if (article_infos) {
                infos.list.push(article_infos);
            }
        }
        return infos;
    }

    add_from_transferable(transferable_inscription) {
        for (let i = 0; i < transferable_inscription.commande_options.length; i++) {
            let commande_option = transferable_inscription.commande_options[i];
            if (commande_option.type == 'article') {


                for (let j = 0; j < this.list.length; j++) {
                    if (this.list[j].id == commande_option.id_item) {

                        this.list[j].quantite_souhaite = commande_option.quantite;
                        if (commande_option.size && commande_option.size != '' && this.list[j].sizes) {
                            for (let k = 0; k < this.list[j].sizes.length; k++) {
                                if (this.list[j].sizes[k].nom == commande_option.size) {
                                    this.list[j].sizes[k].quantite_souhaite = commande_option.quantite;
                                    break;
                                }
                            }
                        }
                    }
                }

            }
        }

    }





}
